export const CART_ATTRIBUTE_UPDATE = `
mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!, $attrKey: String!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      attribute(key: $attrKey) {
        key
        value
      }
    }
    userErrors {
      field
      message
    }
  }
}`
